<template>
  <LoginWrapper>
    <LoginLogo />
    <div class="login-form">
      <div class="login-form__title">Восстановление пароля</div>
      
      <div v-if="!passwordReset">
        <p class="text-center text-muted mb-4">
          Введите новый пароль для вашего аккаунта
        </p>
        
        <b-form @submit.prevent="onSubmit">
          <b-form-group label="Новый пароль:">
            <b-input-group>
              <b-form-input 
                v-model="form.password" 
                :type="showPassword ? 'text' : 'password'"
                required
                :disabled="loading"
                placeholder="Введите новый пароль"
              ></b-form-input>
              <b-input-group-append
                @click="showPassword = !showPassword"
                class="cursor-pointer"
                is-text
              >
                <b-icon scale="1.5" variant="secondary" :icon="showPassword ? 'eye' : 'eye-slash'"></b-icon>
              </b-input-group-append>
            </b-input-group>
            <small class="form-text text-muted">
              Пароль должен содержать минимум 8 символов
            </small>
          </b-form-group>

          <b-form-group label="Подтверждение пароля:">
            <b-input-group>
              <b-form-input 
                v-model="form.password_confirmation" 
                :type="showConfirmPassword ? 'text' : 'password'"
                required
                :disabled="loading"
                placeholder="Подтвердите новый пароль"
              ></b-form-input>
              <b-input-group-append
                @click="showConfirmPassword = !showConfirmPassword"
                class="cursor-pointer"
                is-text
              >
                <b-icon scale="1.5" variant="secondary" :icon="showConfirmPassword ? 'eye' : 'eye-slash'"></b-icon>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-overlay class="mt-5" :show="loading">
            <button
              :class="{ disable: disableButton }"
              type="submit"
              class="login-form__submit"
              :disabled="disableButton || loading"
            >
              <span v-if="loading">Сброс пароля...</span>
              <span v-else>Сбросить пароль</span>
            </button>
          </b-overlay>
        </b-form>
      </div>

      <div v-else class="text-center">
        <div class="mb-3">
          <b-icon icon="check-circle-fill" variant="success" font-scale="3"></b-icon>
        </div>
        <h5 class="text-success mb-3">Пароль успешно сброшен!</h5>
        <p class="text-muted mb-4">
          Ваш пароль был успешно обновлен. Теперь вы можете войти в систему с новым паролем.
        </p>
        <b-button 
          variant="primary" 
          @click="goToLogin"
          class="login-form__submit"
          style="height: 50px;"
        >
          Перейти к авторизации »
        </b-button>
      </div>

      <div class="text-center mt-4">
        <b-link :to="'/login'" class="text-primary">
          ← Вернуться к авторизации
        </b-link>
      </div>
    </div>
  </LoginWrapper>
</template>

<script>
import LoginWrapper from "@components/login/LoginWrapper.vue";
import LoginLogo from "@components/login/LoginLogo.vue";

export default {
  name: 'PasswordReset',
  components: {
    LoginWrapper,
    LoginLogo,
  },
  data() {
    return {
      form: {
        token: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
      showPassword: false,
      showConfirmPassword: false,
      loading: false,
      passwordReset: false,
    };
  },

  computed: {
    disableButton() {
      return !this.form.password || 
             !this.form.password_confirmation ||
             this.form.password !== this.form.password_confirmation ||
             this.form.password.length < 8;
    },
  },

  mounted() {
    // Получаем токен и email из URL параметров
    this.form.token = this.$route.query.token || '';
    this.form.email = this.$route.query.email || '';

    if (!this.form.token || !this.form.email) {
      this.$toast.error('Неверная ссылка для сброса пароля', {
        position: "top-center",
        timeout: 5000,
      });
      this.$router.push('/login');
    }
  },

  methods: {
    async onSubmit() {
      if (this.disableButton || this.loading) return;

      this.loading = true;

      try {
        const response = await api.call('post', '/api/password/reset', this.form);

        if (response.status === 200) {
          this.passwordReset = true;
          this.$toast.success('Пароль успешно сброшен!', {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: true,
            draggablePercent: 1,
            showCloseButtonOnHover: true,
            hideProgressBar: true,
            closeButton: "button",
            icon: "fa fa-check-circle",
            rtl: false,
          });
        }
      } catch (error) {
        console.error('Password reset error:', error);
        
        let errorMessage = 'Произошла ошибка при сбросе пароля. Попробуйте еще раз.';
        
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.response.data.error) {
            errorMessage = error.response.data.error;
          }
        }

        this.$toast.error(errorMessage, {
          position: "top-center",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: true,
          draggablePercent: 1,
          showCloseButtonOnHover: true,
          hideProgressBar: true,
          closeButton: "button",
          icon: "fa fa-exclamation-triangle",
          rtl: false,
        });
      } finally {
        this.loading = false;
      }
    },

    goToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>

